module.exports = __webpack_public_path__ + "img/user-avatar.04488be2.png";